import script from "./FormElementTable.vue?vue&type=script&setup=true&lang=js"
export * from "./FormElementTable.vue?vue&type=script&setup=true&lang=js"

import "./FormElementTable.vue?vue&type=style&index=0&id=7620ad49&lang=scss"

const __exports__ = script;

export default __exports__